import React from "react";

import { TableCell, TableRow } from "@mui/material";
import clsx from "clsx";

import mainStyles from "../../../styles";

export const UserAttributesTableHeader = () => {
  const classes = mainStyles();
  return (
    <TableRow data-testid="user-field-table-header">
      <TableCell className={clsx(classes.tableCell)} align="center">
        Field Name
      </TableCell>
      <TableCell className={clsx(classes.tableCell)} align="center">
        Values
      </TableCell>
    </TableRow>
  );
};
